import React, { useState } from "react";
import "./Partner.css";
import icon1 from "../../../images/Icons_and_images/manage multiple project.png";
import icon2 from "../../../images/Icons_and_images/labour_attendance.png";
import icon3 from "../../../images/Icons_and_images/site reporting.png";
import "@fontsource/manrope";
import "@fontsource/syne";

const cards = [
  {
    number: "01",
    icon: icon1,
    hoverIcon: require("../../../images/Icons_and_images/task and issues hover.png"),
    title: "Promoters &\nLandLord",
    features: [
      "Resource Allocation and Optimization",
      "Cost Management",
      "Real-time Project Tracking",
    ],
  },
  {
    number: "02",
    icon: icon2,
    hoverIcon: require("../../../images/Icons_and_images/manage_multiple_project_hover.png"),
    title: "Contrators",
    features: [
      "Effective Planning and Planning",
      "Enhance Transpering with Clients on Project Status",
      "Cost and Resource Management",
    ],
  },
  {
    number: "03",
    icon: icon3,
    hoverIcon: require("../../../images/Icons_and_images/site reporting hover.png"),
    title: "Site\nEngineer",
    features: [
      "Smooth Collaboration With SubContractors and Vendors.",
      "Real Time Project Update",
    ],
  },
];

const Projectprogress = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <section className="pm-section">
      <div className="pm-container">
        <div className="pm-header">
          <p className="pm-eyebrow">What We Offer</p>
          <h2 className="pm-title">Manage Your Projects</h2>
          <p className="pm-subtitle">
            Purpose-built tools for every stakeholder on your construction project.
          </p>
        </div>

        <div className="pm-grid">
          {cards.map((card, i) => (
            <div
              key={i}
              className={`pm-card ${hoveredIndex === i ? "pm-card--active" : ""}`}
              onMouseEnter={() => setHoveredIndex(i)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="pm-card-top">
                <div className="pm-icon-wrap">
                  <img
                    src={hoveredIndex === i ? card.hoverIcon : card.icon}
                    width="36"
                    height="36"
                    alt=""
                    className="pm-icon"
                  />
                </div>
                <span className="pm-number">{card.number}</span>
              </div>

              <h3 className="pm-card-title">
                {card.title.split("\n").map((line, j) => (
                  <span key={j}>{line}{j < card.title.split("\n").length - 1 && <br />}</span>
                ))}
              </h3>

              <ul className="pm-feature-list">
                {card.features.map((feat, j) => (
                  <li key={j} className="pm-feature-item">
                    <span className="pm-feat-dot" aria-hidden="true" />
                    {feat}
                  </li>
                ))}
              </ul>

              <div className="pm-card-accent" aria-hidden="true" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projectprogress;